<div
  class="grid h-screen w-full min-w-0 transition-[grid-template-columns] duration-300 ease-in-out"
  [style.gridTemplateColumns]="collapsed() ? '85px minmax(0, 1fr)' : '300px minmax(0, 1fr)'"
  [style.maxHeight]="'calc(100vh - 3.5rem)'"
>
  <div
    class="bg-surface-100 border-r border-surface-300 h-full overflow-hidden relative transition-all duration-300"
  >
    <div class="flex justify-end">
      <button
        (click)="toggleSidebar()"
        class="pt-2 self-start text-surface-500 hover:text-surface-700 transition-colors"
        [attr.aria-label]="collapsed() ? 'Expand Client List' : 'Collapse Client List'"
      >
        <i class="pi" [ngClass]="collapsed() ? 'pi-angle-right' : 'pi-angle-left'"></i>
      </button>
    </div>
    <ng-content select="[column1]"></ng-content>
  </div>

  <div class="flex min-w-0 flex-col h-full bg-white min-h-0">
    <bn-client-metadata></bn-client-metadata>
    <div
      class="relative z-0 flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden"
    >
      <ng-content select="[column2]"></ng-content>
    </div>
  </div>
</div>
